import moment from 'moment';
import React from 'react';
import ProfileCell from '../../../Pages/Stakeholder/User/ProfileCell';
import BookingDateAndTime from '../../Blocks/BookingDateAndTime';
import Stars from '../../Stars';
import { connect } from "react-redux";
import Chip from '../Chips';
import Icon from '../Icons/Icon';
import { P3, P3Bold, CaptionSmall, P4Bold } from '../Text';
import colours from '../Colours';
import { DivisionIcon } from '../../Buttons/TypeIcons';
import { openPullout } from '../../../../Actions/stakeholderActions';

const BareBookingRow = (props) => {
    const { booking, openBooking } = props;

    const returnedConditionalSnapshot = booking.vehicleConditionalSnapshots.find(snapshot => snapshot.type === 'returned');

    const renderDivisions = (profile) => {
        var divisions = [];
        var tooltip = [];

        //To prevent duplicates
        var current_divisions = {};
        if (profile?.sh_vmh_access) {
            if (profile.sh_vmh_access.length > 0) {
                profile.sh_vmh_access.map((access, index) => {
                    if (! (access.stakeholder.SH_ID in current_divisions)) {
                        current_divisions[access.stakeholder.SH_ID] = true
                        if (index < 3) {
                            divisions.push(
                                <React.Fragment key={access.stakeholder.SH_ID}>
                                    {DivisionIcon(access.stakeholder, null, null, null, true)}
                                </React.Fragment>
                            )
                        } 
                        else {
                            tooltip.push(
                                ((tooltip.length > 0 ? "<br>" : "") + (access.stakeholder.Display_Name ? access.stakeholder.Display_Name : access.stakeholder.Company)) + " " + access.stakeholder.Division
                            )
                        }
                    }
                })
            } else {
                divisions.push(
                    <React.Fragment key={'service_booking'}>
                        <Icon name="Minus" size={20} style={{color: colours.primary.grey04}}/>
                    </React.Fragment>
                )
            }
        }

        return (
            <div style={{display: 'flex', flexDirection: 'row', paddingTop: profile?.sh_vmh_access.length > 0 ? 10 : 0, justifyContent: 'center'}}>
                {divisions}
                {tooltip.length > 0 ? 
                    <div 
                        style={{width: 24, height: 24, borderRadius: 24, backgroundColor: colours.primary.blue, display: 'flex', alignItems: 'center', justifyContent:'center', marginLeft: 5}} 
                        data-multiline 
                        data-tip={tooltip}
                    >
                       <P3Bold style={{color: 'white'}}>
                            +{tooltip.length}
                        </P3Bold>
                    </div> : null 
                }
            </div>
        )
    }

    return (
        <tr className="ds-booking-row" style={{backgroundColor: props.alt ? '#F4F6F8' : 'white'}} onClick={() => openBooking(booking)}>
            <td className="align-center">
                <div style={{display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center'}}>
                    <Chip type={booking.status}/>
                </div>
            </td>
            <td className="align-left" style={{width: 200}}>
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center'}}>
                    <Icon name={booking.type === 'service' ? "Car" : booking.type === 'profile' ? "User" : "Tag"} size={24} />
                    <div style={{display: 'flex', flex: 1, flexDirection: 'column', minHeight: 72}}>
                        <div style={{marginLeft: 4, display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'center'}}>
                            {booking.type === 'service' ? (
                                <>
                                    <P3Bold>Service</P3Bold>
                                    <P3 style={{ color: colours.primary.grey02 }}>{booking.usageType}</P3>
                                </>
                            ) : (
                                <P3Bold>{booking.releasedTo}</P3Bold>
                            )}
                        </div>
                    </div>
                </div>
            </td>
            <td className="align-center">
                <span>
                    <span>{renderDivisions(booking.legacyApiBooking?.profile)}</span>
                </span>
            </td>
            {/* <td className="align-center">
                {booking.legacyApiBooking?.profile?.Is_User == 1 && booking.legacyApiBooking?.profile?.sh_vmh_access[0]?.tier?.Rank ? <Stars type={"Profile"} ID={booking.legacyApiBooking?.Profile_ID} star={(booking.legacyApiBooking?.profile?.sh_vmh_access[0].tier.Rank)} /> : <P3Bold>N/A</P3Bold>}
            </td> */}
            <td className="align-center">
                <div style={{display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center'}}>
                    {/* <BookingDateAndTime show_time={true} booking={booking}/> */}
                    <DS_BookingDateAndTime booking={booking}/>
                </div>
            </td>
            <td className="align-left">
                <P3Bold>{booking.usageType}</P3Bold>
            </td>
            <td className="align-center">
                <P3Bold>{moment(booking.scheduledReturnedAt).diff(moment(booking.scheduledReleasedAt), 'days')}</P3Bold>
            </td>
            <td className="align-center">
                {Boolean(returnedConditionalSnapshot.isDamaged) && (
                    <div style={{display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center'}}>
                        <Icon name="Damage" size={24} style={{ borderRadius: '8px', border: `solid 1px ${colours.accent.error_red}` }}/>
                    </div>
                )}
            </td>
            <td className="align-center">
                {Boolean(booking.legacyApiBooking?.expense) && (
                    <div style={{display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center'}}>
                        <Icon name="Expenses" size={24} style={{ borderRadius: '8px', border: `solid 1px ${colours.accent.error_red}` }}/>
                    </div>
                )}
            </td>
        </tr>
    )
}

const DS_BookingDateAndTime = ({ booking }) => {
    const scheduledReleasedAt = moment(booking.scheduledReleasedAt).format('YYYY-MM-DDTHH:mm:ssZ');
    const scheduledReturnedAt = moment(booking.scheduledReturnedAt).format('YYYY-MM-DDTHH:mm:ssZ');

    return (
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
            <Icon name="Release" size={24} style={{ borderRadius: '8px' }} class={booking.actualReleasedAt ? 'ds-activity-card-icon' : 'ds-activity-card-icon-grey'}/>
            <div style={{textAlign: 'left', marginLeft: 4, width: 78}}>
                <P3Bold>{moment(scheduledReleasedAt).format('MMM DD, YYYY')}</P3Bold>
                <CaptionSmall>{moment(scheduledReleasedAt).format('hh:mm a')}</CaptionSmall>
            </div>
            <Icon name="ArrowRight" size={24} style={{marginLeft: 0, marginRight: 4}}/>
            <Icon name="CheckIn" size={24} style={{ borderRadius: '8px' }} class={booking.actualReturnedAt ? 'ds-activity-card-icon' : 'ds-activity-card-icon-grey'}/>
            <div style={{textAlign: 'left', marginLeft: 4, width: 78}}>
                <P3Bold>{moment(scheduledReturnedAt).format('MMM DD, YYYY')}</P3Bold>
                <CaptionSmall>{moment(scheduledReturnedAt).format('hh:mm a')}</CaptionSmall>
            </div>
        </div>
    )
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    stakeholder: store.stakeholder,
    settings: store.settings
})

const BookingRow = connect(mapStateToProps)(BareBookingRow);
export {BookingRow, DS_BookingDateAndTime}